import styled from 'styled-components';
import useTranslations from '~/components/translation/use-translations';
import { WE_SPIN_GAME_ROOM_MY_RETURN } from '../constants/we-spin-text-keys';
import currencyFormatter from '~/libs/currency-formatter';
import { H1, LabelBold } from '@comeon/ui';
import { useSelector } from 'react-redux';
import { selectCurrency, selectLocale } from '~/components/account/ducks';

const Wrapper = styled.div`
	border-radius: 12px;
	background-color: var(--link-list, rgba(var(--base-10), 1));
	display: flex;
	flex-flow: column;
	align-items: center;
`;

/**
 * Displays the player's current return balance inside a styled container.
 *
 * @param {Object} props - Component props.
 * @param {number} props.balance - The amount to display, formatted as currency.
 * @returns {JSX.Element|false}
 */
const ReturnBalance = props => {
	const { translations, isLoadingTranslations } = useTranslations([WE_SPIN_GAME_ROOM_MY_RETURN]);
	const locale = useSelector(selectLocale);
	const playerCurrency = useSelector(selectCurrency);

	if (isLoadingTranslations) return false;
	return (
		<Wrapper className="u-p1">
			<LabelBold>{translations.WE_SPIN_GAME_ROOM_MY_RETURN}</LabelBold>
			<H1>{currencyFormatter.format(props.balance, playerCurrency, locale)}</H1>
		</Wrapper>
	);
};

export default ReturnBalance;
